import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {tabletMediaQuery} from '../../../styles';
import ComicsChapterCard from '../ComicChapterCard';

const ChaptersGrid = ({chapters}) => {
    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, []);

    const [cardWidth, setCardWidth] = useState(undefined);
    const [columns, setColumns] = useState(4);

    const updateColumns = width => {
        if (width > 1024) {
            setColumns(4);
            setCardWidth(252);
        } else if (width > 900) {
            setColumns(4);
            setCardWidth((width - 80) / 4);
        } else if (width > 600) {
            setColumns(3);
            setCardWidth((width - 80) / 3);
        } else {
            setColumns(1);
            setCardWidth(width - 50);
        }
    };

    const handleWindowResize = evt => {
        updateColumns(evt.target.innerWidth);
    };
    if (cardWidth === undefined) {
        updateColumns(window.innerWidth);
    }

    return (
        <Container columns={columns} width={cardWidth * columns}>
            {chapters.map((item, index) => {
                return (
                    <ComicsChapterCard
                        chapter={item}
                        height={columns === 1 ? cardWidth * 0.6 : 161}
                        width={cardWidth}
                        maskStart={
                            columns === 1 ? index !== 0 : index % columns !== 0
                        }
                        maskEnd={
                            columns === 1
                                ? index !== chapters.length - 1
                                : index % columns !== columns - 1
                        }
                        horizontal={columns !== 1}
                    />
                );
            })}
        </Container>
    );
};

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    grid-gap: ${props => (props.columns === 1 ? '0' : '15')}px 0px;
    width: ${props => props.width}px;

    ${tabletMediaQuery} {
        padding: 0px 40px;
    }
`;

export default ChaptersGrid;
